import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';
import './style.css';

class Tarjetas_Inferior extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
    }

    render() {
        return (
            <React.Fragment>
                <div className="design-responsive-lowerMenu">
                    <div className="container-fluid tarjetas_inferior_home">
                        <div className="row" style={{ marginLeft: '-15px', marginRight: '-15px !important', }}>
                            <Link to={{ pathname: '/Productos/12/cdat', state: { idtipopers: 1 } }} className="card border">
                                <div className="card-body text-center">
                                    <div className="text-center" style={{ color: '#707070' }}>
                                        <img width="80" className="img-fluid icono-tarjeta" src={`${URLImgFront}/assets/iconos/InvierteDinero.svg`}  alt="resuelve-img" />
                                        <p className="pt-3 texto-inferior-tarjeta">Invierte tu dinero</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to={{ pathname: '/Productos/1/libre_inversión', state: { idtipopers: 1 } }} className="card border">
                                <div className="card-body">
                                    <div className="text-center" style={{ color: '#707070' }}>
                                        <img width="80" className="img-fluid icono-tarjeta" src={`${URLImgFront}/assets/iconos/SolicitaCredito.svg`} alt="resuelve_dudas-img" />
                                        <p className="pt-3 texto-inferior-tarjeta">Solicita tu crédito</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to={{ pathname: '/Productos/9/utramás', state: { idtipopers: 1 } }} className="card border">
                                <div className="card-body">
                                    <div className="text-center" style={{ color: '#707070' }}>
                                        <img width="80" className="img-fluid icono-tarjeta" src={`${URLImgFront}/assets/iconos/Ahorra.svg`} alt="ahorra-img" />
                                        <p className="pt-3 texto-inferior-tarjeta">Ahorra y cumple tus metas</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to={{ pathname: '/Productos/11/utravivienda', state: { idtipopers: 1 } }} className="card border">
                                <div className="card-body">
                                    <div className="text-center" style={{ color: '#707070' }}>
                                        <img width="80" className="img-fluid icono-tarjeta" src={`${URLImgFront}/assets/iconos/Casa.svg`} alt="casa-img" />
                                        <p className="pt-3 texto-inferior-tarjeta">La casa de tus sueños</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/PSE" className="card border">
                                <div className="card-body">
                                    <div className="text-center" style={{ color: '#707070' }}>
                                        <img width="80" className="img-fluid icono-tarjeta" src={`${URLImgFront}/assets/iconos/PagoEnLinea.svg`} alt="pagos_linea-img" />
                                        <p className="pt-3 texto-inferior-tarjeta">Pagos en Línea por PSE</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/Canales_Atencion" className="card border">
                                <div className="card-body">
                                    <div className="text-center" style={{ color: '#707070' }}>
                                        <img width="80" className="img-fluid icono-tarjeta" src={`${URLImgFront}/assets/iconos/CanalesAtencion.svg`} alt="invierte-img" />
                                        <p className="pt-3 texto-inferior-tarjeta">Canales de atención</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Tarjetas_Inferior;